import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import PublicLayout from "@/layouts/PublicLayout";
import { AuthLayout } from "@/layouts/AuthLayout";

// Lazy load Marketing/Info Pages
const HomePage = lazy(() =>
  import("../pages/Site/HomePage")
);

const PhotogrammetryPage = lazy(() =>
  import("@/pages/Site/PhotogrammetryPage")
);

const ThermalImagingPage = lazy(() =>
  import("@/pages/Site/ThermalImagingPage")
);

const LidarMappingPage = lazy(() =>
  import("@/pages/Site/LidarMappingPage")
);

const MultispectralImagingPage = lazy(() =>
  import("@/pages/Site/MultispectralImagingPage")
);

const ContactPage = lazy(() =>
  import("@/pages/Site/ContactPage")
);

const PortfolioPage = lazy(() =>
  import("@/pages/Site/PortfolioPage")
);

const PortfolioCaseStudyPage = lazy(() =>
  import("@/pages/Site/PortfolioCaseStudyPage")
);

const NewsPage = lazy(() =>
  import("@/pages/Site/NewsPage")
);

const NewsArticlePage = lazy(() =>
  import("@/pages/Site/NewsArticlePage")
);

const IndustriesPage = lazy(() =>
  import("@/pages/Site/IndustriesPage")
);

const SolutionsPage = lazy(() =>
  import("@/pages/Site/SolutionsPage")
);

const EnergyResourcesPage = lazy(() =>
  import("@/pages/Site/EnergyResourcesPage")
);

const InfrastructureDevelopmentPage = lazy(() =>
  import("@/pages/Site/InfrastructureDevelopmentPage")
);

// Lazy load Auth Flow Components
const ResetPasswordPage = lazy(() =>
  import("@/pages/Auth/ResetPasswordPage")
);

const VerifyEmailPage = lazy(() =>
  import("@/pages/Auth/VerifyEmailPage")
);

const LoginPage = lazy(() =>
  import("@/pages/Auth/LoginPage")
);

const RegisterPage = lazy(() =>
  import("@/pages/Auth/RegisterPage")
);

const ForgotPasswordPage = lazy(() =>
  import("@/pages/Auth/ForgotPasswordPage")
);

const PublicRoutes: RouteObject[] = [
  {
    element: <PublicLayout />,

    children: [
      {
        index: true,
        element: <HomePage />,
      },

      {
        path: "photogrammetry",
        element: <PhotogrammetryPage />,
      },

      {
        path: "thermal-imaging",
        element: <ThermalImagingPage />,
      },

      {
        path: "lidar-mapping",
        element: <LidarMappingPage />,
      },

      {
        path: "multispectral-imaging",
        element: <MultispectralImagingPage />,
      },

      {
        path: "contact",
        element: <ContactPage />,
      },

      {
        path: "portfolio",
        element: <PortfolioPage />,
      },

      {
        path: "portfolio/:slug",
        element: <PortfolioCaseStudyPage />,
      },
      {
        path: "news",
        element: <NewsPage />,
      },

      {
        path: "news/:slug",
        element: <NewsArticlePage />,
      },


      {
        path: "industries",
        children: [
          {
            index: true,
            element: <IndustriesPage />,
          },

          {
            path: "energy-resources",
            element: <EnergyResourcesPage />,
          },

          {
            path: "infrastructure-development",
            element: <InfrastructureDevelopmentPage />,
          },
        ],
      },

      {
        path: "solutions",
        element: <SolutionsPage />,
      },
    ],
  },

  {
    element: <AuthLayout />,

    children: [
      {
        path: "login",
        element: <LoginPage />,
      },

      {
        path: "register",
        element: <RegisterPage />,
      },

      {
        path: "account",
        children: [
          {
            path: "forgot-password",
            element: <ForgotPasswordPage />,
          },

          {
            path: "change-password",
            element: <ResetPasswordPage />,
          },
        ],
      },

      {
        path: "verify-account",
        element: <VerifyEmailPage />,
      },
    ],
  },
];

export default PublicRoutes;
